import * as z from "zod"

export const OidcLoginGroupDbModel = z.object({
  id: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  workspaceId: z.string(),
  oidcProviderId: z.string(),
  groupValue: z.string().nullish(),
  allowAllUsers: z.boolean(),
})
